/**
* @file 运营中心-用户反馈
* */
<template>
  <div id="driverFeedback">
    <custom-table
      :hasChannel="true"
      has-organization="true"
      ref="customTable"
      :customOptions="customOptions"
      :columns="columns"
      style="height: calc(100vh - 160px)"
    >
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <div slot-scope="{ row }" class="custom-action">
            <el-button
              type="text"
              @click="actionFn({ type: 'detail', row: row })"
              >详情
            </el-button>
          </div>
        </el-table-column>
      </template>

      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">
          {{ row[item.prop] | filterTime }}
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <el-dialog
      title="反馈详情"
      :before-close="handClose"
      :visible.sync="showCancel"
      destroy-on-close
      :wrapperClosable="false"
      width="500px"
    >
      <el-form label-width="40px">
        <el-form-item label="标签" v-if="rowData.feedbackLabel">
          <el-tag type="info" style="margin: 0 5px 5px 0" v-for="item in rowData.feedbackLabel" :key="item">{{item}}</el-tag>
        </el-form-item>
        <el-form-item label="内容">
          <p>{{ rowData.content }}</p>
        </el-form-item>
        <el-form-item label="图片" v-if="rowData.feedbackImg">
          <el-image
            v-for="(item, index) in rowData.feedbackImg"
            :key="index"
            :src="item"
            :preview-src-list="rowData.feedbackImg"
            :initial-index="index"
            style="width: 90px; height: 90px; margin: 0 5px 5px 0"
          ></el-image>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handClose">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "driverFeedback",
  data() {
    return {
      loading: false,

      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/driver/hitchRide/feedback",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "select",
            field: "feedbackLabel",
            name: "标签",
            value: "",
            option: [],
            clearable: true,
          },
        ],
      },
      // 表头
      columns: [
        { prop: "driverName", label: "司机姓名", minWidth: 80 },
        { prop: "driverPhone", label: "联系电话", minWidth: 100 },
        { prop: "receivingCity", label: "接单城市", minWidth: 80 },
        { prop: "feedbackLabel", label: "标签", minWidth: 250 },
        { prop: "content", label: "内容", minWidth: 250 },
        { prop: "created", label: "提交时间", width: 130 },
        { prop: "channelName", label: "归属渠道", width: 130 },
      ],

      showCancel: false,
      rowData: {},
    };
  },
  async created() {
    this.getLabel();
  },
  methods: {
    async getLabel() {
      const url = "/api/v1/manage/driver/hitchRide/feedback/label";
      const { code, data } = await this.$axios.get(url);
      if(code === 1 && data) {
        this.customOptions.search[2].option = data.split(",").map((item) => {
          return {
            label: item,
            value: item,
          };
        });
      }
    },
    actionFn({ type, row }) {
        switch (type) {
          case "detail":
            this.rowData = {...row};
            this.rowData.feedbackLabel = row.feedbackLabel ? row.feedbackLabel.split(",") : row.feedbackLabel;
            this.rowData.feedbackImg = row.feedbackImg ? row.feedbackImg.split(",").map(item => {
              return this.mixinQiniuImg(item)
            }) : '',
            this.showCancel = true;
            break;
        }
    },
    /**
     * 状态改变
     */

    handClose() {
      this.rowData = {};
      this.showCancel = false;
    },
  },
};
</script>

<style scoped lang="less">
</style>
